import { useIsUserBidder } from "@/app/bids/hooks"
import { BlockchainsMoleculeReatom } from "@/app/blockchains/blockchain-molecule.reatom"
import { useEvent } from "@/app/hooks/use-event"
import { useEvmCancelByOrder } from "@/app/sdk/action-molecules/evm/evm-cancel-by-order-molecule"
import { useSolanaCancelByOrder } from "@/app/sdk/action-molecules/solana/solana-cancel-by-order-molecule"
import type { BidItem } from "@anaconda/core/bid/types"
import { getBlockchainFromAddress } from "@anaconda/core/blockchain/address"
import { Trans } from "@lingui/react/macro"
import { Button } from "@rarible_int/anaconda_ui_components"
import { useMolecule } from "bunshi/react"

export function Action({ bidItem }: { bidItem: BidItem }) {
  const isUserBidder = useIsUserBidder(bidItem.bid)

  const targetId =
    bidItem.entity.type === "collection"
      ? bidItem.entity.collection.id
      : bidItem.entity.nft.id
  const blockchain = getBlockchainFromAddress(targetId)

  const { reatomIsEvmBlockchain } = useMolecule(BlockchainsMoleculeReatom)
  const isEvmBlockchain = reatomIsEvmBlockchain()(blockchain)
  const hook = isEvmBlockchain ? useEvmCancelByOrder : useSolanaCancelByOrder
  const { mutate } = hook(bidItem.bid.order.id, blockchain)

  const handleClick = useEvent(() => {
    mutate()
  })

  if (!isUserBidder) return null

  return (
    <div>
      <Button variant="secondary" onClick={handleClick}>
        <Trans>Cancel</Trans>
      </Button>
    </div>
  )
}
